import * as Yup from "yup";

export const RecruitFormValidation = Yup.object({
  firstName: Yup.string().required("First Name is required"),
  middleName: Yup.string().optional(),
  lastName: Yup.string().required("Last Name is required"),
  commonName: Yup.string().optional(),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string()
    .nullable()
    .length(12, "Does not match pattern +16049999999")
    .matches(/^\+\d{1,3}\d{7,14}$/, "Must include country code and area code, e.g. +16049999999"),
  address: Yup.string().optional(),
  jobTitleId: Yup.string().required("Position is required"),
  managerId: Yup.string().required("Hiring Manager is required"),
});
